var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('Header',{attrs:{"msg":"Header"}}),_c('SettingsHeader',{attrs:{"msg":"SettingsHeader"}})],1),_c('main',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"editor"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }